/**
 * The tools' friendly names, as the PiPar app shows them while the AI uses one
 * (AIToolsManager.getFriendlyToolName). Generated from the app's translations
 * (pipar/assets/translations/<lang>.json, "tools"); regenerate when they change.
 */

const TOOL_NAMES: Record<string, Record<string, string>> = {
  "de": {
    "ask_persona": "Andere Persona konsultieren",
    "attachments": "Anhänge werden verarbeitet...",
    "close_bulletin_ticket": "Bulletin-Ticket schließen",
    "complete_task": "Aufgabe wird abgeschlossen",
    "compression": "Verlauf wird komprimiert...",
    "create_bulletin_ticket": "Bulletin-Ticket erstellen",
    "create_document": "Dokument wird erstellt",
    "create_follow_up": "Anruf wird erstellt",
    "create_image": "Bild wird erstellt",
    "create_note": "Notiz wird erstellt",
    "create_subtasks": "Unteraufgaben erstellen",
    "create_task": "Aufgabe wird erstellt",
    "delete_checklist": "Checkliste löschen",
    "delete_note": "Notiz wird gelöscht",
    "end_consultation": "Konsultation abschließen",
    "end_conversation": "Gespräch beenden",
    "find_documents": "Dokumente werden gesucht",
    "find_note": "Notiz wird gesucht",
    "find_task": "Aufgabe wird gesucht",
    "get_contacts": "Kontakte nachschlagen",
    "get_messages": "Nachrichten prüfen",
    "get_persona_messages": "Persona-Nachrichten prüfen",
    "get_subtasks": "Unteraufgaben abrufen",
    "get_user_locations": "Standorte abrufen",
    "list_follow_ups": "Anrufe werden aufgelistet",
    "list_projects": "Projekte auflisten",
    "list_todays_tasks": "Heutige Aufgaben auflisten",
    "modify_follow_up": "Anruf bearbeiten",
    "modify_message": "Nachricht bearbeiten",
    "modify_persona": "Persona wird bearbeitet",
    "navigate_to_location": "Navigation zum Standort",
    "open_document": "Dokument wird geöffnet",
    "read_context_item": "Kontext wird gelesen",
    "read_diary_entry": "Tagebuch wird gelesen",
    "read_document": "Dokument wird gelesen",
    "read_memory": "Speicher wird gelesen",
    "remove_memory": "Speicher wird entfernt",
    "save_diary_entry": "Tagebucheintrag wird gespeichert",
    "schedule_tasks": "Aufgaben werden geplant",
    "search_diary_entry": "Tagebuch wird durchsucht",
    "search_memory": "Speicher wird durchsucht",
    "send_message": "Nachricht senden",
    "send_persona_message": "Nachricht an Persona senden",
    "toggle_subtask": "Unteraufgabe umschalten",
    "update_bulletin_ticket": "Bulletin-Ticket aktualisieren",
    "update_memory": "Speicher wird aktualisiert",
    "update_note": "Notiz wird aktualisiert",
    "update_subtasks": "Unteraufgaben aktualisieren",
    "update_task": "Aufgabe wird aktualisiert",
    "usingGenericTool": "Werkzeug wird verwendet",
    "usingTool": "{toolName} wird verwendet",
    "web_search": "Web-Suche",
    "write_context_item": "Kontext wird geschrieben"
  },
  "en": {
    "ask_persona": "Consulting another persona",
    "attachments": "Processing attachments...",
    "close_bulletin_ticket": "Closing bulletin ticket",
    "complete_task": "Completing task",
    "compression": "Compressing history...",
    "create_bulletin_ticket": "Creating bulletin ticket",
    "create_document": "Creating document",
    "create_follow_up": "Creating call",
    "create_image": "Drawing picture",
    "create_note": "Creating note",
    "create_subtasks": "Creating subtasks",
    "create_task": "Creating task",
    "delete_checklist": "Deleting checklist",
    "delete_note": "Deleting note",
    "end_consultation": "Completing consultation",
    "end_conversation": "Ending conversation",
    "find_documents": "Finding documents",
    "find_note": "Finding note",
    "find_task": "Finding task",
    "get_contacts": "Looking up contacts",
    "get_messages": "Checking messages",
    "get_persona_messages": "Checking persona messages",
    "get_subtasks": "Getting subtasks",
    "get_user_locations": "Getting locations",
    "list_follow_ups": "Listing calls",
    "list_projects": "Listing projects",
    "list_todays_tasks": "Listing today's tasks",
    "modify_follow_up": "Modifying call",
    "modify_message": "Modifying message",
    "modify_persona": "Modifying persona",
    "navigate_to_location": "Navigating to location",
    "open_document": "Opening document",
    "read_context_item": "Reading context",
    "read_diary_entry": "Reading diary",
    "read_document": "Reading document",
    "read_memory": "Reading memory",
    "remove_memory": "Removing memory",
    "save_diary_entry": "Saving diary entry",
    "schedule_tasks": "Scheduling tasks",
    "search_diary_entry": "Searching diary",
    "search_memory": "Searching memory",
    "send_message": "Sending message",
    "send_persona_message": "Sending message to persona",
    "toggle_subtask": "Toggling subtask",
    "update_bulletin_ticket": "Updating bulletin ticket",
    "update_memory": "Updating memory",
    "update_note": "Updating note",
    "update_subtasks": "Updating subtasks",
    "update_task": "Updating task",
    "usingGenericTool": "Using tool",
    "usingTool": "Using {toolName}",
    "web_search": "Searching web",
    "write_context_item": "Writing context"
  },
  "es": {
    "ask_persona": "Consultando otra persona",
    "attachments": "Procesando adjuntos...",
    "close_bulletin_ticket": "Cerrando ticket de boletín",
    "complete_task": "Completando tarea",
    "compression": "Comprimiendo historial...",
    "create_bulletin_ticket": "Creando ticket de boletín",
    "create_document": "Creando documento",
    "create_follow_up": "Creando llamada",
    "create_image": "Creando imagen",
    "create_note": "Creando nota",
    "create_subtasks": "Creando subtareas",
    "create_task": "Creando tarea",
    "delete_checklist": "Eliminando lista de verificación",
    "delete_note": "Eliminando nota",
    "end_consultation": "Finalizando consulta",
    "end_conversation": "Finalizando conversación",
    "find_documents": "Buscando documentos",
    "find_note": "Buscando nota",
    "find_task": "Buscando tarea",
    "get_contacts": "Buscando contactos",
    "get_messages": "Revisando mensajes",
    "get_persona_messages": "Revisando mensajes de personas",
    "get_subtasks": "Obteniendo subtareas",
    "get_user_locations": "Obteniendo ubicaciones",
    "list_follow_ups": "Listando llamadas",
    "list_projects": "Listando proyectos",
    "list_todays_tasks": "Listando tareas de hoy",
    "modify_follow_up": "Modificando llamada",
    "modify_message": "Modificando mensaje",
    "modify_persona": "Modificando persona",
    "navigate_to_location": "Navegando a ubicación",
    "open_document": "Abriendo documento",
    "read_context_item": "Leyendo contexto",
    "read_diary_entry": "Leyendo diario",
    "read_document": "Leyendo documento",
    "read_memory": "Leyendo memoria",
    "remove_memory": "Eliminando memoria",
    "save_diary_entry": "Guardando entrada de diario",
    "schedule_tasks": "Programando tareas",
    "search_diary_entry": "Buscando en el diario",
    "search_memory": "Buscando en la memoria",
    "send_message": "Enviando mensaje",
    "send_persona_message": "Enviando mensaje a persona",
    "toggle_subtask": "Alternando subtarea",
    "update_bulletin_ticket": "Actualizando ticket de boletín",
    "update_memory": "Actualizando memoria",
    "update_note": "Actualizando nota",
    "update_subtasks": "Actualizando subtareas",
    "update_task": "Actualizando tarea",
    "usingGenericTool": "Usando una herramienta",
    "usingTool": "Usando {toolName}",
    "web_search": "Buscando en la web",
    "write_context_item": "Escribiendo contexto"
  },
  "fi": {
    "ask_persona": "Konsultoi toista persoonaa",
    "attachments": "Käsitellään liitteitä...",
    "close_bulletin_ticket": "Sulkee ilmoitustaulun tiketin",
    "complete_task": "Merkitsee tehtävän valmiiksi",
    "compression": "Tiivistetään historiaa...",
    "create_bulletin_ticket": "Luo ilmoitustaulun tiketin",
    "create_document": "Luo asiakirjaa",
    "create_follow_up": "Luo puhelutehtävää",
    "create_image": "Piirtää kuvaa",
    "create_note": "Luo muistiinpanoa",
    "create_subtasks": "Luo alitehtäviä",
    "create_task": "Luo tehtävää",
    "delete_checklist": "Poistaa tarkistuslistan",
    "delete_note": "Poistaa muistiinpanoa",
    "end_consultation": "Päättää konsultaation",
    "end_conversation": "Päättää keskustelun",
    "find_documents": "Etsii asiakirjoja",
    "find_note": "Etsii muistiinpanoa",
    "find_task": "Etsii tehtävää",
    "get_contacts": "Hakee yhteystietoja",
    "get_messages": "Tarkistaa viestejä",
    "get_persona_messages": "Tarkistaa persoonaviestejä",
    "get_subtasks": "Hakee alitehtäviä",
    "get_user_locations": "Hakee sijainteja",
    "list_follow_ups": "Listaa puhelut",
    "list_projects": "Listaa projektit",
    "list_todays_tasks": "Listaa tämän päivän tehtävät",
    "modify_follow_up": "Muokkaa puhelua",
    "modify_message": "Muokkaa viestiä",
    "modify_persona": "Muokkaa persoonaa",
    "navigate_to_location": "Navigoi sijaintiin",
    "open_document": "Avaa asiakirjan",
    "read_context_item": "Lukee kontekstia",
    "read_diary_entry": "Lukee päiväkirjaa",
    "read_document": "Lukee asiakirjaa",
    "read_memory": "Lukee muistia",
    "remove_memory": "Poistaa muistista",
    "save_diary_entry": "Tallentaa päiväkirjamerkintää",
    "schedule_tasks": "Aikatauluttaa tehtäviä",
    "search_diary_entry": "Etsii päiväkirjasta",
    "search_memory": "Etsii muistista",
    "send_message": "Lähettää viestiä",
    "send_persona_message": "Lähettää viestiä toiselle persoonalle",
    "toggle_subtask": "Vaihtaa alitehtävän tilaa",
    "update_bulletin_ticket": "Päivittää ilmoitustaulun tiketin",
    "update_memory": "Päivittää muistia",
    "update_note": "Päivittää muistiinpanoa",
    "update_subtasks": "Päivittää alitehtäviä",
    "update_task": "Päivittää tehtävää",
    "usingGenericTool": "Käyttää työkalua",
    "usingTool": "Käyttää työkalua: {toolName}",
    "web_search": "Etsii verkosta",
    "write_context_item": "Kirjoittaa kontekstia"
  },
  "fr": {
    "ask_persona": "Consultation d'un autre persona",
    "attachments": "Traitement des pièces jointes...",
    "close_bulletin_ticket": "Fermeture du ticket de bulletin",
    "complete_task": "Complétion de tâche",
    "compression": "Compression de l'historique...",
    "create_bulletin_ticket": "Création d'un ticket de bulletin",
    "create_document": "Création de document",
    "create_follow_up": "Création d'appel",
    "create_image": "Création d'image",
    "create_note": "Création de note",
    "create_subtasks": "Création de sous-tâches",
    "create_task": "Création de tâche",
    "delete_checklist": "Suppression de la liste",
    "delete_note": "Suppression de note",
    "end_consultation": "Fin de la consultation",
    "end_conversation": "Fin de la conversation",
    "find_documents": "Recherche de documents",
    "find_note": "Recherche de note",
    "find_task": "Recherche de tâche",
    "get_contacts": "Recherche de contacts",
    "get_messages": "Vérification des messages",
    "get_persona_messages": "Vérification des messages de personas",
    "get_subtasks": "Récupération des sous-tâches",
    "get_user_locations": "Récupération des lieux",
    "list_follow_ups": "Liste des appels",
    "list_projects": "Liste des projets",
    "list_todays_tasks": "Liste des tâches du jour",
    "modify_follow_up": "Modification de l'appel",
    "modify_message": "Modification du message",
    "modify_persona": "Modification du persona",
    "navigate_to_location": "Navigation vers le lieu",
    "open_document": "Ouverture de document",
    "read_context_item": "Lecture du contexte",
    "read_diary_entry": "Lecture du journal",
    "read_document": "Lecture de document",
    "read_memory": "Lecture de la mémoire",
    "remove_memory": "Suppression de la mémoire",
    "save_diary_entry": "Enregistrement d'entrée de journal",
    "schedule_tasks": "Planification des tâches",
    "search_diary_entry": "Recherche dans le journal",
    "search_memory": "Recherche dans la mémoire",
    "send_message": "Envoi de message",
    "send_persona_message": "Envoi de message au persona",
    "toggle_subtask": "Basculement de sous-tâche",
    "update_bulletin_ticket": "Mise à jour du ticket de bulletin",
    "update_memory": "Mise à jour de la mémoire",
    "update_note": "Mise à jour de note",
    "update_subtasks": "Mise à jour des sous-tâches",
    "update_task": "Mise à jour de tâche",
    "usingGenericTool": "Utilisation d’un outil",
    "usingTool": "Utilisation de {toolName}",
    "web_search": "Recherche web",
    "write_context_item": "Écriture du contexte"
  }
}

/** "list_todays_tasks" in "fi-FI" -> "Listaa tämän päivän tehtävät". English
 *  when the language has no names; "Using <tool>" for a tool without one. */
export function friendlyToolName(tool: string, language?: string): string {
  const names = TOOL_NAMES[(language || 'en').slice(0, 2).toLowerCase()] || TOOL_NAMES.en
  if (!tool.trim()) return names.usingGenericTool || TOOL_NAMES.en.usingGenericTool
  return names[tool] || TOOL_NAMES.en[tool]
    || (names.usingTool || TOOL_NAMES.en.usingTool).replace('{toolName}', tool.replace(/_/g, ' '))
}
